import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "save-builder-warning" }
const _hoisted_2 = { class: "save-warning" }
const _hoisted_3 = { class: "popup-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "popup-description" }, "Are you sure you want to create this builder?", -1)
const _hoisted_5 = { class: "btns-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "Builder already exists with the name " + _toDisplayString($props.name), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "save-builder",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createBuilder')))
        }, "Create Builder"),
        _createElementVNode("button", {
          class: "cancel-builder",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancelBuilder')))
        }, "Cancel Creation")
      ])
    ])
  ]))
}